import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCompanyCategoryApi,
  createCompanyCategoryApi,
  updateCompanyCategoryApi,
  deleteCompanyCategoryApi,
} from "./companyCategoryApi";

export const getCompanyCategories = createAsyncThunk(
  "companyCategory/get",
  async (_, thunkAPI) => {
    try {
      const res = await getCompanyCategoryApi();
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const createCompanyCategory = createAsyncThunk(
  "companyCategory/create",
  async (data, thunkAPI) => {
    try {
      const res = await createCompanyCategoryApi(data);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const updateCompanyCategory = createAsyncThunk(
  "companyCategory/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateCompanyCategoryApi(id, data);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const deleteCompanyCategory = createAsyncThunk(
  "companyCategory/delete",
  async (id, thunkAPI) => {
    try {
      await deleteCompanyCategoryApi(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const slice = createSlice({
  name: "companyCategory",
  initialState: {
    categories: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })
      .addCase(createCompanyCategory.fulfilled, (state, action) => {
        state.categories.unshift(action.payload);
      })
      .addCase(deleteCompanyCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter(
          (c) => c.id !== action.payload
        );
      })
      .addCase(updateCompanyCategory.fulfilled, (state, action) => {
        const i = state.categories.findIndex(
          (c) => c.id === action.payload.id
        );
        if (i !== -1) state.categories[i] = action.payload;
      });
  },
});

export default slice.reducer;